import styled from 'styled-components'
import { tokens } from '@welbe/web-design-system'

export const Container = styled.div`
	display: grid;
	place-items: center;
	margin: auto;
	height: 70vh;
`

export const Content = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #64778f;
	color: ${tokens.color_gray_dark};

	svg {
		width: 108px;
		height: 108px;
		margin-bottom: 20px;
	}

	h4 {
		margin-bottom: 10px;
	}

	p {
		color: ${tokens.color_primary};
		font-weight: 700;
		font-size: 18px;
		line-height: 26px;
	}
`
